/* Bilingual content for Checkout page */

export const CHECKOUT_CONTENT = {
  en: {
    home: "Home",
    shop: "Shop",
    pageTitle: "Checkout",
    yourDetails: "Your details",
    detailsSubtitle: "Information from your intake form",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    shippingAddress: "Shipping Address",
    addressLine1: "Address Line 1",
    addressLine1Placeholder: "Street address, P.O. box",
    addressLine2: "Address Line 2 (Optional)",
    addressLine2Placeholder: "Apartment, suite, unit, building, floor, etc.",
    city: "City",
    state: "State",
    stateSelect: "Select…",
    postalCode: "Postal Code",
    postalCodePlaceholder: "ZIP / Postal code",
    addOns: "Add-ons (Optional)",
    addOnsSubtitle: "Enhance your order with these optional items",
    syringes: "Syringes (Pack of 10)",
    syringesDesc: "Medical-grade syringes for safe administration",
    payment: "Payment",
    orderSummary: "Order summary",
    selectedProducts: "Select the products you want to purchase",
    qty: "Qty",
    subtotal: "Subtotal",
    shipping: "Shipping & Handling",
    tax: "Tax",
    total: "Total",
    placeOrder: "Pay",
    processing: "Processing…",
    securePayment: "Payments processed securely by Square.",
    errors: {
      completeDetails: "Please complete your details",
      completeAddress: "Please complete your shipping address",
      cardNotReady: "Card form not ready",
      cardInvalid: "Card details are not correct. Please check your information and try again.",
      selectProduct: "Please select at least one product to purchase",
    },
    paymentSuccess: "Payment successful",
  },
  es: {
    home: "Inicio",
    shop: "Tienda",
    pageTitle: "Pagar",
    yourDetails: "Tus detalles",
    detailsSubtitle: "Información de tu formulario de registro",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    shippingAddress: "Dirección de Envío",
    addressLine1: "Línea de Dirección 1",
    addressLine1Placeholder: "Dirección, apartado postal",
    addressLine2: "Línea de Dirección 2 (Opcional)",
    addressLine2Placeholder: "Apartamento, suite, unidad, edificio, piso, etc.",
    city: "Ciudad",
    state: "Estado",
    stateSelect: "Seleccionar…",
    postalCode: "Código Postal",
    postalCodePlaceholder: "Código postal / ZIP",
    addOns: "Complementos (Opcional)",
    addOnsSubtitle: "Mejora tu pedido con estos artículos opcionales",
    syringes: "Jeringas (Paquete de 10)",
    syringesDesc: "Jeringas de grado médico para administración segura",
    payment: "Pago",
    orderSummary: "Resumen del pedido",
    selectedProducts: "Selecciona los productos que deseas comprar",
    qty: "Cant",
    subtotal: "Subtotal",
    shipping: "Envío y Manejo",
    tax: "Impuesto",
    total: "Total",
    placeOrder: "Pagar",
    processing: "Procesando…",
    securePayment: "Pagos procesados de forma segura por Square.",
    errors: {
      completeDetails: "Por favor completa tus detalles",
      completeAddress: "Por favor completa tu dirección de envío",
      cardNotReady: "El formulario de tarjeta no está listo",
      cardInvalid: "Los datos de la tarjeta no son correctos. Por favor revisa tu información e intenta nuevamente.",
      selectProduct: "Por favor selecciona al menos un producto para comprar",
    },
    paymentSuccess: "Pago exitoso",
  },
};

export function getCheckoutContent(lang) {
  return CHECKOUT_CONTENT[lang] || CHECKOUT_CONTENT.en;
}
